import React from 'react';
import { StyledSystemProps } from '../../types';
import pillFilledIcon from './assets/icon-pill-filled.svg';
import pillEmptyIcon from './assets/icon-pill-empty.svg';
import { Rating, Props as RatingProps } from '../../wag-react/components/Rating';
import { Icon } from '../../wag-react/components/icon';
type Props = Omit<RatingProps, 'filledIcon' | 'unfilledIcon'> & {
  iconProps?: StyledSystemProps;
} & StyledSystemProps;
export const PillsRating = ({
  iconProps,
  ...rest
}: Props) => <Rating filledIcon={<Icon width="16px" height="16px" {...iconProps} src={pillFilledIcon} alt="pill-rating-filled" />} unfilledIcon={<Icon width="16px" height="16px" {...iconProps} src={pillEmptyIcon} alt="pill-rating-filled" />} {...rest} data-sentry-element="Rating" data-sentry-component="PillsRating" data-sentry-source-file="index.tsx" />;